import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  categories: [],
};

const sliceOrderTakingCar = createSlice({
  name: "orderTakingCar",
  initialState,
  reducers: {
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
  },
});

export const { setCategories } = sliceOrderTakingCar.actions;
export default sliceOrderTakingCar.reducer;
